import { DetailType } from 'app/modules/detail-module/data';
import {
  AF_COUNTRY,
  AF_PARTICIPATING_ORG_REF,
  AF_REPORTING_ORG_REF,
  AF_TRANSACTION_PROVIDER_ORG_REF,
} from 'app/utils/getAPIFormattedFilters';

export function getDetailBaseFilter(type: DetailType) {
  if (type === 'country') {
    return AF_COUNTRY;
  }
  if (type === 'donor') {
    return AF_TRANSACTION_PROVIDER_ORG_REF;
  }
  if (type === 'publisher') {
    return AF_REPORTING_ORG_REF;
  }
  if (type === 'organisation') {
    return AF_PARTICIPATING_ORG_REF;
  }
  return '';
}
